import React from "react";
import MessageFullWidthBlock from "./MessageFullWidthBlock";
import { checkCircleFill } from "../../components/constants/icons";

const RemovalFromWaitingList = () => {
  const handleClick = () => {
    console.log('clicked goback');
  }
    return (
      <div className="container">
        <MessageFullWidthBlock
            icon={checkCircleFill}
            title="Thank you!"
            message="Subscription is removed from the event successfully."
            buttonText="Go Back!"
            handleButtonClick={handleClick}
        />
      </div>
    );
  }
  
  export default RemovalFromWaitingList;
  